// Régime de TVA du groupe, sous forme d'historique (même règles que ms-business, services/accounting/vatRegime.ts) :
// l'option est basculée « en direct » dans les paramètres du groupe, l'instant du changement est enregistré par le serveur.
// Chaque entrée {from: instant ISO, subjectToVat} est le régime applicable à partir de cet instant, jusqu'à l'entrée suivante.
// Sans historique, le groupe est assujetti à la TVA. Un changement de régime ajoute une entrée, il ne réécrit jamais le passé.

const timeOf = value => new Date(value).getTime();

export function cleanVatRegimes(history) {
    if (!Array.isArray(history)) return [];
    return history
        .filter(entry => entry && !isNaN(timeOf(entry.from)) && typeof entry.subjectToVat === 'boolean')
        .map(entry => ({from: new Date(entry.from).toISOString(), subjectToVat: entry.subjectToVat}))
        .sort((a, b) => timeOf(a.from) - timeOf(b.from));
}

// Dernière milliseconde du jour (UTC) d'une date : une pièce datée du jour du changement suit le nouveau régime
export function endOfDay(date) {
    const time = timeOf(date);
    return isNaN(time) ? new Date() : new Date(Math.floor(time / 86400000) * 86400000 + 86400000 - 1);
}

// Le groupe est-il assujetti à la TVA à cet instant ? (assujetti par défaut)
export function isSubjectToVat(history, date) {
    const time = date ? timeOf(date) : Date.now();
    let subject = true;
    for (const entry of cleanVatRegimes(history)) {
        if (timeOf(entry.from) <= time) subject = entry.subjectToVat;
    }
    return subject;
}

// Une pièce datée d'un jour (facture d'achat) est-elle soumise à la TVA selon le régime en vigueur ce jour-là ?
export function isSubjectToVatOnDay(history, day) {
    return isSubjectToVat(history, endOfDay(day));
}

// Régime en vigueur aujourd'hui
export function currentSubjectToVat(history) {
    return isSubjectToVat(history, new Date());
}
